"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tooltip = void 0;
const radii_1 = require("../basic/radii");
const fonts_1 = require("../basic/fonts");
const shadows_1 = require("../basic/shadows");
exports.tooltip = {
    whiteSpace: 'nowrap',
    top: '-150%',
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'white',
    borderRadius: radii_1.radii.default,
    position: 'absolute',
    display: 'block',
    visibility: 'hidden',
    boxShadow: shadows_1.shadows.tooltip,
    padding: '7px 11px',
    fontSize: fonts_1.fontSizes[1],
    fontWeight: 'bold',
    ':after': {
        content: "''",
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '10px 7px 0 7px',
        borderColor: 'white transparent transparent transparent',
        position: 'absolute',
        bottom: '-9px',
        left: '50%',
        transform: 'translateX(-50%)',
    },
};
//# sourceMappingURL=tooltip.js.map